module.exports = __webpack_public_path__ + "static/media/ruhtinas-white-bg-gold-300x140.06492244.png";